var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", { staticStyle: { "text-align": "center" } }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          model: {
            value: _vm.taskSelectedTab,
            callback: function ($$v) {
              _vm.taskSelectedTab = $$v
            },
            expression: "taskSelectedTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "表单信息", name: "form-first" } },
            [
              _vm.formType === "2"
                ? _c(_vm.form, {
                    ref: "form",
                    tag: "component",
                    class: _vm.formReadOnly ? "readonly" : "",
                    attrs: {
                      id: "printForm",
                      formReadOnly: _vm.formReadOnly,
                      businessId: _vm.businessId,
                    },
                  })
                : _vm._e(),
              _vm.formType !== "2"
                ? _c("PreviewForm", {
                    ref: "form",
                    attrs: {
                      id: "printForm",
                      processDefinitionId: _vm.procDefId,
                      edit: true,
                      taskFormData: _vm.taskFormData,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.procInsId
            ? _c(
                "el-tab-pane",
                { attrs: { label: "流程信息", name: "form-second" } },
                [
                  _c("flow-time-line", {
                    attrs: { historicTaskList: _vm.historicTaskList },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-tab-pane",
            { attrs: { label: "流程图", name: "form-third" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("流程图")])]
                  ),
                  _vm.procInsId
                    ? _c("flow-chart", {
                        ref: "chart1",
                        attrs: { processInstanceId: _vm.procInsId },
                      })
                    : _vm._e(),
                  !_vm.procInsId
                    ? _c("flow-chart", {
                        ref: "chart2",
                        attrs: { processDefId: _vm.procDefId },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.procInsId
            ? _c(
                "el-tab-pane",
                { attrs: { label: "流转记录", name: "form-forth" } },
                [
                  _c("flow-step", {
                    attrs: { historicTaskList: _vm.historicTaskList },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      !_vm.procInsId || _vm.taskId
        ? _c(
            "el-card",
            { staticStyle: { "margin-top": "10px", "padding-bottom": "66px" } },
            [
              _c(
                "el-form",
                {
                  ref: "auditForm",
                  attrs: {
                    size: "small",
                    model: _vm.auditForm,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      !_vm.procInsId
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "流程标题", prop: "title" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入流程标题" },
                                model: {
                                  value: _vm.title,
                                  callback: function ($$v) {
                                    _vm.title = $$v
                                  },
                                  expression: "title",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.taskId
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "审批信息", prop: "message" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "请输入审批意见",
                                },
                                model: {
                                  value: _vm.auditForm.message,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.auditForm, "message", $$v)
                                  },
                                  expression: "auditForm.message",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.isCC,
                                callback: function ($$v) {
                                  _vm.isCC = $$v
                                },
                                expression: "isCC",
                              },
                            },
                            [_vm._v("是否抄送")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _vm.isCC
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                rules: [
                                  {
                                    required: true,
                                    message: "用户不能为空",
                                    trigger: "blur",
                                  },
                                ],
                                prop: "userIds",
                                label: "抄送给",
                              },
                            },
                            [
                              _c(
                                "user-select",
                                {
                                  attrs: { value: _vm.auditForm.userIds },
                                  on: {
                                    getValue: function (value) {
                                      _vm.auditForm.userIds = value
                                    },
                                  },
                                },
                                [_vm._v(">")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.isAssign,
                                callback: function ($$v) {
                                  _vm.isAssign = $$v
                                },
                                expression: "isAssign",
                              },
                            },
                            [_vm._v("指定下一步处理者(不设置就使用默认处理人)")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _vm.isAssign
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                rules: [
                                  {
                                    required: true,
                                    message: "用户不能为空",
                                    trigger: "blur",
                                  },
                                ],
                                prop: "assignee",
                                label: "指定",
                              },
                            },
                            [
                              _c(
                                "user-select",
                                {
                                  attrs: {
                                    limit: 1,
                                    value: _vm.auditForm.assignee,
                                  },
                                  on: {
                                    getValue: function (value) {
                                      _vm.auditForm.assignee = value
                                    },
                                  },
                                },
                                [_vm._v(">")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "FlowFormFooter" },
        [
          _vm._l(_vm.buttons, function (button, index) {
            return [
              button.isHide === "0"
                ? [
                    button.code !== "_flow_print"
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              { name: "noMoreClick", rawName: "v-noMoreClick" },
                            ],
                            key: index,
                            attrs: { type: "primary", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.submit(button, _vm.buttons)
                              },
                            },
                          },
                          [_vm._v(_vm._s(button.name))]
                        )
                      : _vm._e(),
                    button.code === "_flow_print"
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "print",
                                rawName: "v-print",
                                value: _vm.printObj,
                                expression: "printObj",
                              },
                              { name: "noMoreClick", rawName: "v-noMoreClick" },
                            ],
                            key: index,
                            attrs: { type: "primary", plain: "" },
                          },
                          [_vm._v(_vm._s(button.name))]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _c("task-back-nodes", {
        ref: "taskBackNodes",
        on: { getBackTaskDefKey: _vm.back },
      }),
      _c("user-select-dialog", {
        ref: "transferUserSelectDialog",
        attrs: { title: "选择转办用户", limit: 1 },
        on: { doSubmit: _vm.selectUsersToTransferTask },
      }),
      _c("user-select-dialog", {
        ref: "delegateUserSelectDialog",
        attrs: { title: "选择委派用户", limit: 1 },
        on: { doSubmit: _vm.selectUsersToDelateTask },
      }),
      _c("user-select-dialog", {
        ref: "addSignTaskUserSelectDialog",
        attrs: { title: "选择加签用户" },
        on: { doSubmit: _vm.selectUsersToAddSignTask },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }